import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {
  CLASSIFICATION_CALCULATION_ERROR_DIALOG_MESSAGE,
  CLASSIFICATION_CALCULATION_ERROR_DIALOG_RESULT,
} from '../../company-form.classification';

export interface ClassificationCalculationErrorDialogData {
  // Per-flow label for the "proceed without the preview" button: 'Save anyway' on an edit save,
  // 'Submit anyway' on a submit-for-verification.
  continueLabel: string;
}

// INI-13125: shown when the classification-calculate dry-run fails (HTTP error, or a result item
// with status error / skipped_missing_fields). "Try again" closes 'retry' so the caller re-runs
// the calculation; the labeled continue button closes 'continue' so the save/submit proceeds
// without the preview (the backend runs the engine on its own); the header X closes null and
// aborts the whole action. Structure follows the shared cf-dialog pattern.
@Component({
  selector: 'app-classification-calculation-error-dialog',
  template: `
    <div class="cf-dialog">
      <div class="cf-dialog__header">
        <h2 class="cf-dialog__title">{{ MESSAGE.TITLE }}</h2>
        <button type="button" class="cf-dialog__close" (click)="abort()" aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>

      <div class="cf-dialog__divider"></div>

      <div class="cf-dialog__body">
        <p class="ccd-body__text">{{ MESSAGE.BODY }}</p>
      </div>

      <div class="cf-dialog__footer">
        <button type="button" class="rp-button rp-outlined rp-primary" (click)="retry()">
          {{ MESSAGE.RETRY }}
        </button>
        <button type="button" class="rp-button rp-filled rp-primary" (click)="continueAnyway()">
          {{ data.continueLabel }}
        </button>
      </div>
    </div>
  `,
  styleUrls: ['./classification-calculation-error-dialog.component.scss'],
})
export class ClassificationCalculationErrorDialogComponent {
  readonly MESSAGE = CLASSIFICATION_CALCULATION_ERROR_DIALOG_MESSAGE;

  constructor(
    public readonly dialogRef: MatDialogRef<ClassificationCalculationErrorDialogComponent, 'retry' | 'continue' | null>,
    @Inject(MAT_DIALOG_DATA) public readonly data: ClassificationCalculationErrorDialogData,
  ) {}

  retry(): void {
    this.dialogRef.close(CLASSIFICATION_CALCULATION_ERROR_DIALOG_RESULT.RETRY);
  }

  continueAnyway(): void {
    this.dialogRef.close(CLASSIFICATION_CALCULATION_ERROR_DIALOG_RESULT.CONTINUE);
  }

  abort(): void {
    this.dialogRef.close(null);
  }
}
